import { gql } from '@apollo/client/core';

export const getCounties = gql`
  query getCounties {
    getCounties {
      state
      county
    }
  }
`;
